// extracted by mini-css-extract-plugin
module.exports = {"button":"_3R2kam","form":"_2ANAe7"};